import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function P0SyncDatePickerModal({ show, onHide, onDateSelect }) {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDateSelect = () => {
    if (selectedDate) {
      onDateSelect(selectedDate);
    }
  };

  return (
    <Modal animation={false} centered show={show} onHide={onHide} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Select Date to Analyze P0 Sync Gaps</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <Form.Label className="font-weight-bold">
              Select a date to analyze P0 sync execution gaps:
            </Form.Label>
            <div className="mt-3">
              <DatePicker
                selected={selectedDate}
                onChange={date => setSelectedDate(date)}
                customInput={<Form.Control />}
                placeholderText="Select Date"
                dateFormat="yyyy-MM-dd"
                maxDate={new Date()}
                className="form-control"
              />
            </div>
            <div className="mt-2">
              <small className="text-muted">
                This will analyze the selected day for any missed P0 sync time periods and show you
                options to create tasks for those periods.
              </small>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleDateSelect} disabled={!selectedDate}>
          Analyze Gaps
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

P0SyncDatePickerModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onDateSelect: PropTypes.func.isRequired,
};

export default P0SyncDatePickerModal;
